import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { object } from "yup";
import PURCHASEIRQCreditScoreView from "../views/IrqCreditScoreView";
import { validationMap } from "../validations/validationMap";
import StatusCheck from "../components/StatusCheck";

class RefinanceIrqCreditScorePage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="refinanceIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={validationMap.RefinanceIrqCreditScorePage}
        >
          <PURCHASEIRQCreditScoreView
            content={contentMap.RefinanceIrqCreditScorePage}
            navigationsAway={customNavigationMap.RefinanceIrqCreditScorePage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(RefinanceIrqCreditScorePage);
